import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import './theme/speed.css'
import './theme/classic.css'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import router from './router'
import { useAppStore } from './stores/app'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
// Applies the chosen colour theme before the first paint
useAppStore(pinia)
app.use(i18n)
app.use(router)
app.use(ui)

createSentry(app)

router.isReady().then(() => app.mount('#app'))
